export const MysteryType = {
    coin1: 'coin_1_complete',
    coin2: 'coin_2_complete',
    coin5Complete: 'coin_5_complete',
    coin5Fragment: 'coin_5_fragment',
    coin10Complete: 'coin_10_complete',
    coin10Fragment: 'coin_10_fragment',
    coin15: 'coin_15_fragment',
    coin20: 'coin_20_fragment',
    coin30: 'coin_30_fragment',
    coin50: 'coin_50_fragment',
    coin100: 'coin_100_fragment',
    chris20: 'chris_20_complete',
    chris150: 'chris_150_fragment',
    chris200: 'chris_200_fragment',
} as const;

export type IMysteryType = typeof MysteryType[keyof typeof MysteryType];


export const MysteryShapeType = {
    [`${MysteryType.coin1}`]: {
        count: 1,
        image: 'num1.png',
    },
    [`${MysteryType.coin2}`]: {
        count: 1,
        image: 'num2.png',
    },
    [`${MysteryType.coin5Complete}`]: {
        count: 1,
        image: 'num5.png',
    },
    [`${MysteryType.coin10Complete}`]: {
        count: 1,
        image: 'num10.png',
    },
    [`${MysteryType.coin5Fragment}`]: {
        count: 2,
        imageDir: 'coin5',
    },
    [`${MysteryType.coin10Fragment}`]: {
        count: 3,
        imageDir: 'coin10',
    },
    [`${MysteryType.coin15}`]: {
        count: 4,
        imageDir: 'coin15',
    },
    [`${MysteryType.coin20}`]: {
        count: 4,
        imageDir: 'coin20',
    },
    [`${MysteryType.coin30}`]: {
        count: 5,
        imageDir: 'coin30',
    },
    [`${MysteryType.coin50}`]: {
        count: 5,
        imageDir: 'coin50',
    },
    [`${MysteryType.coin100}`]: {
        count: 6,
        imageDir: 'coin100',
    },
    [`${MysteryType.chris20}`]: {
        count: 1,
        image: 'chris20.png',
    },
    [`${MysteryType.chris150}`]: {
        count: 3,
        imageDir: 'chris150',
    },
    [`${MysteryType.chris200}`]: {
        count: 3,
        imageDir: 'chris200',
    },
};

export const MysteryBgMap = {
    [`${MysteryType.coin1}`]: 'mysteryBoxBg2.jpg',
    [`${MysteryType.coin2}`]: 'mysteryBoxBg2.jpg',
    [`${MysteryType.coin5Complete}`]: 'mysteryBoxBg2.jpg',
    [`${MysteryType.coin10Complete}`]: 'mysteryBoxBg2.jpg',
    [`${MysteryType.coin5Fragment}`]: 'mysteryBoxBg2.jpg',
    [`${MysteryType.coin10Fragment}`]: 'mysteryBoxBg2.jpg',
    [`${MysteryType.coin15}`]: 'mysteryBoxBg2.jpg',
    [`${MysteryType.coin20}`]: 'mysteryBoxBg2.jpg',
    [`${MysteryType.coin30}`]: 'mysteryBoxBg2.jpg',
    [`${MysteryType.coin50}`]: 'mysteryBoxBg2.jpg',
    [`${MysteryType.coin100}`]: 'mysteryBoxBg2.jpg',
    [`${MysteryType.chris20}`]: 'chrisBg.png',
    [`${MysteryType.chris150}`]: 'chrisBg.png',
    [`${MysteryType.chris200}`]: 'chrisBg.png',
};
export interface IFragmentInfo {
    // 已收集的碎片个数
    collectedCount: number;
    // 收集碎片的目标数量
    targetCount: number;
}

export interface IMysteryInfo {
    // 用户获得的奖品物品ID
    prizeItemGuid?: string;
    // 奖品形态类型 1 - 完整形态 2 - 碎片形态（无编号）3 - 碎片形态（有编号，后续需求）
    shapeType: 1 | 2 | 3;
    // 奖品id
    prizeGuid: string;
    // 奖品分类 是知识币 还是 数字典藏
    category?: 1 | 2;
    // 奖品名称
    name: string;
    // 奖品类型 是哪种奖品
    prizeKey: IMysteryType;
    // 碎片信息
    fragmentInfo: IFragmentInfo;
    // 奖品数量
    amount?: number;
}

export const ShapeType = {
    full: 1,
    shard: 2,
    shardId: 3,
};

export const MysteryBoxTypeImg = {

};
